import {
  DEFAULT_MEMBER_REQUIRED_FIELDS,
  MEMBER_REQUIRED_FIELD_NAMES,
  ConfigurableMemberField,
  MemberRequiredField,
  MemberRequiredFields,
} from '../member-required-fields.model';

export function memberRequiredFieldsFromConfigs(configs: { name: string; isEnabled: boolean }[]): MemberRequiredFields {
  const fields = { ...DEFAULT_MEMBER_REQUIRED_FIELDS };
  for (const field of Object.keys(MEMBER_REQUIRED_FIELD_NAMES) as ConfigurableMemberField[]) {
    const config = configs.find(item => item.name === MEMBER_REQUIRED_FIELD_NAMES[field]);
    if (config) fields[field] = config.isEnabled === true;
  }
  const locationRequired = fields.city || fields.neighborhood;
  fields.city = locationRequired;
  fields.neighborhood = locationRequired;
  const emergencyRequired = fields.emergencyPhone || fields.emergencyRelation;
  fields.emergencyPhone = emergencyRequired;
  fields.emergencyRelation = emergencyRequired;
  return fields;
}

export function isRequiredMemberInfoComplete(
  member: {
    name?: string | null;
    lastNames?: string | null;
    cellPhone?: string | null;
    email?: string | null;
    birthdate?: string | null;
    address?: string | null;
    cityId?: number | null;
    neighborhoodId?: number | null;
    emergencyPhone?: string | null;
    emergencyRelation?: string | null;
    medicalConditions?: string | null;
    hasPhoto?: boolean | null;
  },
  required: MemberRequiredFields,
): boolean {
  return (Object.keys(required) as MemberRequiredField[]).every(field => {
    if (!isMemberFieldRequired(required, field)) return true;
    if (field === 'city') return Boolean(member.cityId);
    if (field === 'neighborhood') return Boolean(member.neighborhoodId);
    if (field === 'photo') return member.hasPhoto === true;
    return Boolean(member[field]?.toString().trim());
  });
}

export function isMemberFieldRequired(required: MemberRequiredFields, field: MemberRequiredField): boolean {
  if (field === 'name' || field === 'lastNames' || field === 'cellPhone') return true;
  if (field === 'city' || field === 'neighborhood') return required.city || required.neighborhood;
  if (field === 'emergencyPhone' || field === 'emergencyRelation')
    return required.emergencyPhone || required.emergencyRelation;
  return required[field];
}
